import { SMSTag } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { InboxTag } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';

export const dedupeSMSTagsArray = (tags: SMSTag[]): SMSTag[] => {
  const tagsObj: Record<string, SMSTag> = {};
  tags.forEach((tag) => {
    const existingTag = tagsObj[tag.tagId];
    if (!existingTag) {
      tagsObj[tag.tagId] = tag;
    } else {
      const isNewerThanExisting = tag.smsCreatedAt > existingTag.smsCreatedAt;
      if (isNewerThanExisting) {
        tagsObj[tag.tagId] = tag;
      }
    }
  });

  return Object.values(tagsObj).sort((a, b) =>
    a.smsCreatedAt > b.smsCreatedAt ? -1 : a.smsCreatedAt < b.smsCreatedAt ? 1 : 0
  );
};

/**
 * Deduplicates an array of InboxTags based on tagId and entityId combination.
 * For unified threads, InboxTags have entityId instead of smsId like SMSTags.
 */
export const dedupeInboxTagsArray = (tags: InboxTag[]): InboxTag[] => {
  const tagsObj: Record<string, InboxTag> = {};

  tags.forEach((tag) => {
    const existingTag = tagsObj[tag.tagId];
    if (!existingTag) {
      tagsObj[tag.tagId] = tag;
    } else {
      // Keep the newer tag based on entityCreatedAt (equivalent to smsCreatedAt in SMSTag)
      const isNewerThanExisting = tag.entityCreatedAt > existingTag.entityCreatedAt;
      if (isNewerThanExisting) {
        tagsObj[tag.tagId] = tag;
      }
    }
  });

  // Sort by entityCreatedAt (newest first) - same sorting logic as SMSTags
  return Object.values(tagsObj).sort((a, b) =>
    a.entityCreatedAt > b.entityCreatedAt ? -1 : a.entityCreatedAt < b.entityCreatedAt ? 1 : 0
  );
};
